module.exports = __webpack_public_path__ + "img/desktop_active.e874ef94.svg";